import { styled } from '@material-ui/core';

export const DigiDateWrapper = styled('div')({
    '& .react-datepicker-wrapper':{
        width:'100%',
    },
    '& input': {
        minWidth: '200px'
    }
})
